import * as Schema from "effect/Schema";
import * as Rpc from "effect/unstable/rpc/Rpc";
import * as RpcGroup from "effect/unstable/rpc/RpcGroup";
import { EnvironmentAuthorizationError } from "./auth.ts";
import { ProviderInstanceId } from "./providerInstance.ts";

export const ClaudeAccountSignInState = Schema.Union([
  Schema.Struct({
    state: Schema.Literals(["idle", "starting", "verifying", "connected", "cancelled"]),
  }),
  Schema.Struct({ state: Schema.Literal("authorizing"), url: Schema.optionalKey(Schema.String) }),
  Schema.Struct({ state: Schema.Literal("failed"), reason: Schema.String }),
]);
export type ClaudeAccountSignInState = typeof ClaudeAccountSignInState.Type;
export const ClaudeAccountSignInCommand = Schema.Struct({
  instanceId: ProviderInstanceId,
  action: Schema.Literals(["start", "status", "cancel"]),
});
export type ClaudeAccountSignInCommand = typeof ClaudeAccountSignInCommand.Type;
export class ClaudeAccountSignInError extends Schema.TaggedErrorClass<ClaudeAccountSignInError>()(
  "ClaudeAccountSignInError",
  { message: Schema.String },
) {}
export const CLAUDE_ACCOUNT_SIGN_IN_RPC = "claudeAccount.signIn";
export const ClaudeAccountSignInRpcGroup = RpcGroup.make(
  Rpc.make(CLAUDE_ACCOUNT_SIGN_IN_RPC, {
    payload: ClaudeAccountSignInCommand,
    success: ClaudeAccountSignInState,
    error: Schema.Union([ClaudeAccountSignInError, EnvironmentAuthorizationError]),
  }),
);
